var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 3.83335L8.19177 8.90002C7.8501 9.45002 8.2501 10.1667 8.9001 10.1667H15.0918C15.7418 10.1667 16.1418 9.45002 15.8001 8.90002L12.7084 3.83335C12.3834 3.30002 11.6168 3.30002 11.2918 3.83335Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5835 19.3333C18.6546 19.3333 20.3335 17.6544 20.3335 15.5833C20.3335 13.5122 18.6546 11.8333 16.5835 11.8333C14.5124 11.8333 12.8335 13.5122 12.8335 15.5833C12.8335 17.6544 14.5124 19.3333 16.5835 19.3333Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 18.6667H10.3333C10.7917 18.6667 11.1667 18.2917 11.1667 17.8333V12.8333C11.1667 12.375 10.7917 12 10.3333 12H5.33333C4.875 12 4.5 12.375 4.5 12.8333V17.8333C4.5 18.2917 4.875 18.6667 5.33333 18.6667Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.4e294daa60c604a20942003a25cebcdd.svg";
export { ForwardRef as ReactComponent };